/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 */
export function createColumns(page = 1) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Aula",
      dataIndex: "aula",
      key: "aula",
      sorter: (a, b) => a.aula.localeCompare(b.aula)
    },
    {
      title: "Canal",
      dataIndex: "canal",
      key: "canal",
      sorter: (a, b) => a.canal - b.canal
    },
    {
      title: "Pabellón",
      dataIndex: "pabellon",
      key: "pabellon",
      sorter: (a, b) => a.pabellon.localeCompare(b.pabellon)
    },
    {
      title: "Salón",
      dataIndex: "salon",
      key: "salon",
      sorter: (a, b) => a.salon.localeCompare(b.salon)
    },
    {
      title: "Piso",
      dataIndex: "piso",
      key: "piso",
      sorter: (a, b) => a.piso.localeCompare(b.piso)
    }
    // {
    //   title: "Rango",
    //   dataIndex: "rango",
    //   key: "rango",
    //   sorter: (a, b) => a.rango.localeCompare(b.rango)
    // }
  ];
}
